<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <kt-row>
                    <kt-col lg="12" md="12" sm="12">
                        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                    </kt-col>
                    <kt-col lg="6" md="6" sm="12"></kt-col>
                </kt-row>

            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
    import { ApiUrl } from '@/common/api.service'
    import columns from './datatable/vpn-log-columns'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import mainContent from '@/components/main-content'

    export default {
        components: {
            mainContent,
            //transactionFilter,
        },
        computed: {
            datatableProps() {
                return {
                    id: "vpn_log_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('settlement/vpn-log'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    // this.$refs.datatable.reload()

                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        saveState: {
                            // save datatable state(pagination, filtering, sorting, etc) in cookie or browser webstorage
                            cookie: false,
                            webstorage: false,
                        },
                        pageSize: 30,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },

                    pagination: false,
                    sortable: false,
                    columns: columns,
                }
            }
        }
    }
</script>

<style scoped>

</style>